<div class="list-page kapea" style="max-width: 1000px">
  <app-asiakas-otsikko otsikko="Selaa tuotteita" [asiakas]="asiakas()"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding: 10px; margin-bottom: 20px; max-width: 600px; position: relative" class="mat-elevation-z2">
      <span style="font-size: 10px; position: absolute; top: 3px; right: 5px" class="light-gray-text">(Vain devaajat)</span>
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Tuotteet (Lemonaid): <a [href]="laskuTuotteetEncodedUriObservable | async" target="_BLANK">{{ laskuTuotteetUriObservable | async }}</a>
      </div>
    </div>
  }

  <div class="ylaosan-kontrollit">
    <div class="hakukontrollit">
      <mat-form-field>
        <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
        <mat-label>Etsi tuotteita</mat-label>
        <input type="text" matInput readonly (click)="avaaHaku()" (keydown.enter)="avaaHaku()" (keydown.space)="$event.preventDefault(); avaaHaku()" style="cursor: pointer" aria-label="Avaa tuotehaku" />
      </mat-form-field>
    </div>
  </div>

  <div style="position: relative">
    <mat-table matSort [dataSource]="dataSource" [matSortDisableClear]="true" style="min-height: 94px">
      <ng-container matColumnDef="ulkoinenTunniste">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 140px">Ulk. tunniste</mat-header-cell>
        <mat-cell *matCellDef="let row" class="mono" style="max-width: 140px">{{ row.ulkoinenTunniste || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nimi">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Nimi</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.nimi }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="yksikko">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 90px">Yksikkö</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 90px">{{ row.yksikko || '–' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="hinta">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 130px; justify-content: flex-end">Hinta (€)</mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 130px; justify-content: flex-end">{{ row.hinta | number: '1.2-2' : 'fi-FI' }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row (click)="avaa(row)" *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    @if ((rivienMaaraObservable | async) === 0 && (lataaObservable | async) === false) {
      <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
        <div style="width: 100%; padding-top: 40px; text-align: center; color: #888">Ei tuotteita.</div>
      </div>
    }
  </div>

  <mat-paginator [length]="rivienMaaraObservable | async" [pageSize]="20" [pageSizeOptions]="[20, 50, 200]"></mat-paginator>
</div>
<app-tuoterekisteri-haku-lemonator [avoinna]="hakuAvoinna" (suljettu)="suljeHaku()"></app-tuoterekisteri-haku-lemonator>
